module.exports = __webpack_public_path__ + "img/20200613_094923.5a360303.jpg";